<script lang="ts">
  import IconDefaultNull from '@/comps-sdk/components/icon/default-null.svelte';

  export let nullText = '暂无数据';
</script>

<template>
  <div class="default-panel">
    <IconDefaultNull />
    <div class="default-text">
      {nullText}
    </div>
  </div>
</template>

<style lang="scss">
  .default-panel {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .default-text {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 16px;
      color: rgba(25, 25, 25, 0.5);
    }
  }
</style>
